import Request from "@/common/net/request.js";
const request = new Request();

// 设备状态分布
export function getDeviceDistribute(data) {
  return request.send({
    url: `/joker/index/device/distribute`,
    method: "get",
  });
}
// 统计订单的数量
export function getOrderCount(data) {
  return request.send({
    url: `/joker/index/order/count`,
    method: "get",
  });
}

// 订单类型分布
export function getOrderDistribute(data) {
  return request.send({
    url: `/joker/index/order/distribute`,
    method: "get",
  });
}

// 用户终端分布
export function getUserDistribute(data) {
  return request.send({
    url: `/joker/index/user/distribute`,
    method: "get",
  });
}

// 订单抢单结果趋势
export function getOrderTrend(year) {
  return request.send({
    url: `/joker/index/order/trend?year=${year}`,
    method: "get",
  });
}
